import { StateType } from '../index';
import { BaseCaptchaStore } from './CaptchaReducer';

export const getCaptchaSelector = (state: StateType) => state.get('captcha') as BaseCaptchaStore;

export const getCaptchaExpiredSelector = (state: StateType) => (state.get('captcha') as BaseCaptchaStore).isExpired;

export const getCaptchaExpiresAtSelector = (state: StateType) => (state.get('captcha') as BaseCaptchaStore).expiresAt;
